var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTakeIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14.6667H18.5V13.3333H8.508C8.2 13.3253 7.83333 13.2033 7.83333 12.6667C7.83333 12.13 8.2 12.008 8.508 12H18.5V2.66666C18.5 1.93133 17.902 1.33333 17.1667 1.33333H8.5C7.696 1.33333 6.5 1.86599 6.5 3.33333V12.6667C6.5 14.134 7.696 14.6667 8.5 14.6667ZM9 10.6667L18 11.5003C18 10.9637 17.2 2.67466 17.5 2.66666L17.1667 2.66666V10.6667L18 4.50032L9 10.6667Z",
    fill: "#11B55F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83337 4H15.8334V5.33333H9.83337V4Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0715 16.3375C22.6003 15.8917 21.8657 15.9208 21.3705 16.3375L17.6812 19.4167C17.23 19.7958 16.667 20 16.084 20H11.3605C11.0091 20 10.7217 19.7 10.7217 19.3333C10.7217 18.9667 11.0091 18.6667 11.3605 18.6667H14.4869C15.1218 18.6667 15.7127 18.2125 15.8165 17.5583C15.9483 16.725 15.3334 16 14.5548 16H8.16624C7.08818 16 6.04605 16.3875 5.20755 17.0958L3.35088 18.6667H1.13885C0.787484 18.6667 0.5 18.9667 0.5 19.3333V23.3333C0.5 23.7 0.787484 24 1.13885 24H15.3853C15.9642 24 16.5272 23.7958 16.9824 23.4167L23.0196 18.375C23.6265 17.8708 23.6744 16.9042 23.0715 16.3375Z",
    fill: "#11B55F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeIcon2);
export default __webpack_public_path__ + "static/media/takeIcon2.d76105968d1cb5b17807a9ffbadd15b9.svg";
export { ForwardRef as ReactComponent };